export default {
    routeChange: false,
    showMenu: false,
    header_title: null,
}
